import React from 'react';
import Link from "next/link";
import Icon from "@atoms/icon";
import ChevronLeftIcon from "@icons/chevron-left.svg";

const SiteMapMainLinks = ({handleUrl, city, handleAreaUrl, hasArea, isGolbahar}) => {
    return (
        <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
                <Link href="/properties" as={handleUrl(city.name, 'sale', 'apartment')}>
                    <a className="mt-24 d-flex align-items-center items-link" title={`خرید آپارتمان در ${city.name}`}>
                        <span className="text-ellipsis">خرید آپارتمان در {city.name}</span>
                        <Icon width={5} className="mr-8">
                            <ChevronLeftIcon/>
                        </Icon>
                    </a>
                </Link>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
                <Link href="/properties" as={handleUrl(city.name, 'rent', 'apartment')}>
                    <a className="mt-24 d-flex align-items-center items-link" title={`اجاره آپارتمان در ${city.name}`}>
                        <span className="text-ellipsis">اجاره آپارتمان در {city.name}</span>
                        <Icon width={5} className="mr-8">
                            <ChevronLeftIcon/>
                        </Icon>
                    </a>
                </Link>
            </div>

            {
                (hasArea && !isGolbahar) ?
                    <div className="col-12 col-md-6 col-lg-4">
                        <a href={handleAreaUrl(city.name)} className="mt-24 d-flex align-items-center items-link" title={`نقشه ${city.name}`}>
                            <span className="text-ellipsis">نقشه {city.name}</span>
                            <Icon width={5} className="mr-8">
                                <ChevronLeftIcon/>
                            </Icon>
                        </a>
                    </div>
                    : ''
            }

            {
                (isGolbahar) ?
                    <Link href="/properties" as={handleUrl(city.name, 'sale', 'land')}>
                        <a className="mt-24 d-flex align-items-center items-link" title={`خرید زمین ${city.name}`}>
                            <span className="text-ellipsis">خرید زمین {city.name}</span>
                            <Icon width={5} className="mr-8">
                                <ChevronLeftIcon/>
                            </Icon>
                        </a>
                    </Link>
                    : ''
            }
        </div>
    );
};

export default React.memo(SiteMapMainLinks);
